import { useTranslation } from "react-i18next";

import type { RemoteErrorStatus } from "src/api/remoteCollectionState";
import { RemoteErrorAlert } from "src/components/PageState/RemoteErrorAlert";

export type ScoreQueryErrorContext = "catalog" | "details";

type ScoreQueryErrorProps = {
    context: ScoreQueryErrorContext;
    onRetry?: () => void | Promise<unknown>;
    status: RemoteErrorStatus;
};

export const ScoreQueryError = ({ context, onRetry, status }: ScoreQueryErrorProps) => {
    const { t } = useTranslation();

    const message = context === "catalog" ? getCatalogErrorMessage(status) : getDetailsErrorMessage(status);

    return <RemoteErrorAlert message={message} onRetry={onRetry} status={status} />;

    function getCatalogErrorMessage(errorStatus: RemoteErrorStatus) {
        switch (errorStatus) {
            case "contract-error":
                return t("score.select.error.contract", "Score data is incomplete. Please refresh and try again.");
            case "forbidden":
                return t("score.select.error.forbidden", "You are not allowed to view score options.");
            case "not-found":
                return t("score.select.error.notFound", "Score options were not found.");
            case "server-error":
                return t("score.select.error.server", "Score options could not be loaded. Please try again.");
        }
    }

    function getDetailsErrorMessage(errorStatus: RemoteErrorStatus) {
        switch (errorStatus) {
            case "contract-error":
                return t(
                    "product.score_details.contract_error",
                    "Score data is incomplete. Please refresh and try again.",
                );
            case "forbidden":
                return t("product.score_details.forbidden", "You are forbidden from viewing these score details.");
            case "not-found":
                return t("product.score_details.not_found", "These score details were not found.");
            case "server-error":
                return t("product.score_details.server_error", "Score details could not be loaded. Please try again.");
        }
    }
};
